<div>
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-progress">
      @if (viewLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    <div class="kt-portlet__head-label kt-modal-header">
      <div class="kt-header-title">
        <span class="kt-portlet__head-title">{{data.title | translate}}</span>
        <span class="kt-portlet__head-icon kt-hide">
          <i class="la la-gear"></i>
        </span>
      </div>
      <div>
        <button class="close-dialog-icon-button"
          [attr.aria-label]="'aria.close_dialog' | translate"
          mat-icon-button
          (click)="closeDialog()"
          >
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>

  </div>
  <div class="kt-form">
    <div style="overflow: auto" class="kt-portlet__body scroll-div">

      <div class="flex-row" >

        @if (!data.innerHtml) {
          <div style="align-self: center; max-height: 525px;overflow: auto;" class="scroll-div">
            <span class="UWSlim" style="font-size: 1rem;  font-weight: 700;">
              {{viewLoading ? data.waitDesciption : data.description}}
            </span>
          </div>
        }

      </div>

      <ng-content></ng-content>

    </div>
    @if (!viewLoading && !data.hideFooter) {
      <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
        <div class="kt-form__actions kt-form__actions--sm">
          @if (data.singleBtn) {
            <button  (click)="singleBtnClick()" type="button" class="btn btn-primary">
              <span class="kt-hidden-mobile">{{ (data.singleBtnLabel ? data.singleBtnLabel : cancelBtnText) | translate}}</span>
            </button>
          }
          @if (!data.singleBtn) {
            <uw-button customClass="uw-stroked-button uw-button--medium mx-2" type="button" (click)="onNoClick()" btnLabel="{{ (data.cancelBtnLabel ? data.cancelBtnLabel : cancelBtnText) | translate }}"></uw-button>
          }
          @if (data.showYesBtn) {
            <button  (click)="onYesClick()" cdkFocusInitial [disabled]="viewLoading" type="button" class="btn btn-primary">
              <i class="la la-check"></i>
              <span class="kt-hidden-mobile">{{data.confirmButton | translate}}</span>
            </button>
          }
          <ng-content select="[saveButton]"></ng-content>
        </div>
      </div>
    }
  </div>
</div>